var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-map",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.422,
    height: 15.486,
    viewBox: "0 0 17.422 15.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "map-marked-alt-solid_1_",
    "data-name": "map-marked-alt-solid (1)",
    d: "M8.711,0A3.811,3.811,0,0,0,4.9,3.811c0,1.7,2.491,4.8,3.445,5.929a.477.477,0,0,0,.732,0c.954-1.126,3.445-4.227,3.445-5.929A3.811,3.811,0,0,0,8.711,0Zm0,5.081a1.27,1.27,0,1,1,1.27-1.27A1.27,1.27,0,0,1,8.711,5.081Zm-8.1,1.45A.968.968,0,0,0,0,7.43V15a.484.484,0,0,0,.664.449l4.176-1.9V6.5A9.16,9.16,0,0,1,4.2,5.1Zm8.1,4.347a1.445,1.445,0,0,1-1.1-.513c-.595-.7-1.227-1.5-1.8-2.32v5.5l5.807,1.936V8.046c-.572.819-1.2,1.619-1.8,2.32A1.446,1.446,0,0,1,8.711,10.879Zm8.047-6-4.176,1.9v8.711l4.231-1.692a.968.968,0,0,0,.609-.9V5.324a.484.484,0,0,0-.664-.449Z",
    transform: "translate(0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMap);
export default __webpack_public_path__ + "static/media/ic-map.23b921168d9ddc9500a254835e3748f4.svg";
export { ForwardRef as ReactComponent };